// Note - static imports like this are kind of a pain, but they enable 
// cache-busting file name hashes, among other benefits.
// For a comparison of this approach vs the public folder, see:
// https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-the-public-folder
import robot1_short from './assets/sounds/Koobot_Processed_01B.mp3';
import robot2_short from './assets/sounds/Koobot_Processed_02B.mp3';
import robot3_short from './assets/sounds/Koobot_Processed_03B.mp3';
import robot4_short from './assets/sounds/Koobot_Processed_04B.mp3';
import robot5_short from './assets/sounds/Koobot_Processed_05B.mp3';
import robot6_short from './assets/sounds/Koobot_Processed_06B.mp3';
import robot7_short from './assets/sounds/Koobot_Processed_07B.mp3';
import robot8_short from './assets/sounds/Koobot_Processed_08B.mp3';
import robot9_short from './assets/sounds/Koobot_Processed_09B.mp3';

import robot1_long from './assets/sounds/Koobot_Processed_01A.mp3';
import robot2_long from './assets/sounds/Koobot_Processed_02A.mp3';
import robot3_long from './assets/sounds/Koobot_Processed_03A.mp3';
import robot4_long from './assets/sounds/Koobot_Processed_04A.mp3';
import robot5_long from './assets/sounds/Koobot_Processed_05A.mp3';
import robot6_long from './assets/sounds/Koobot_Processed_06A.mp3';
import robot7_long from './assets/sounds/Koobot_Processed_07A.mp3';
import robot8_long from './assets/sounds/Koobot_Processed_08A.mp3';
import robot9_long from './assets/sounds/Koobot_Processed_09A.mp3';

import success from './assets/sounds/E_01_WIN.mp3';
import fail from './assets/sounds/E_01_FAIL.mp3';

import success_1 from './assets/success/DM-Positive-Clip-1.mp3';
import success_2 from './assets/success/DM-Positive-Clip-2.mp3';
import success_3 from './assets/success/DM-Positive-Clip-3.mp3';
import success_4 from './assets/success/DM-Positive-Clip-4.mp3';
import success_5 from './assets/success/DM-Positive-Clip-5.mp3';
import success_6 from './assets/success/DM-Positive-Clip-6.mp3';
import success_7 from './assets/success/DM-Positive-Clip-7.mp3';
import success_8 from './assets/success/DM-Positive-Clip-8.mp3';

import fail_1 from './assets/success/DM-Negative-Clip-1.mp3';
import fail_2 from './assets/success/DM-Negative-Clip-2.mp3';
import fail_3 from './assets/success/DM-Negative-Clip-3.mp3';
import fail_4 from './assets/success/DM-Negative-Clip-4.mp3';
import fail_5 from './assets/success/DM-Negative-Clip-5.mp3';
import fail_6 from './assets/success/DM-Negative-Clip-6.mp3';


// createjs is a globally included script
var createjs = window.createjs;

/*
    Note - I'm pretty sure you can't possibly use HTMLAudioPlugin
    with Preloadjs. Doesn't seem to be well documented.
    So if we need to use HTMLAudioPlugin (ie. for IE support)
    we'll have to drop Preloadjs and just use createjs.Sound.registerSound
*/
createjs.Sound.registerPlugins([createjs.WebAudioPlugin, createjs.HTMLAudioPlugin]);

// sound 'types';
export const SOUND_LONG = 'long';
export const SOUND_SHORT = 'short';

function idForSound(sound_type, robot_index) {
    return sound_type + '_' + robot_index;
}

export const all_sounds = [
    {id: 'long_1', src: robot1_long},
    {id: 'long_2', src: robot2_long},
    {id: 'long_3', src: robot3_long},
    {id: 'long_4', src: robot4_long},
    {id: 'long_5', src: robot5_long},
    {id: 'long_6', src: robot6_long},
    {id: 'long_7', src: robot7_long},
    {id: 'long_8', src: robot8_long},
    {id: 'long_9', src: robot9_long},

    {id: 'short_1', src: robot1_short},
    {id: 'short_2', src: robot2_short},
    {id: 'short_3', src: robot3_short},
    {id: 'short_4', src: robot4_short},
    {id: 'short_5', src: robot5_short},
    {id: 'short_6', src: robot6_short},
    {id: 'short_7', src: robot7_short},
    {id: 'short_8', src: robot8_short},
    {id: 'short_9', src: robot9_short},

    {id: 'success', src: success},
    {id: 'fail', src: fail},

    {id: 'success_1', src: success_1},
    {id: 'success_2', src: success_2},
    {id: 'success_3', src: success_3},
    {id: 'success_4', src: success_4},
    {id: 'success_5', src: success_5},
    {id: 'success_6', src: success_6},
    {id: 'success_7', src: success_7},
    {id: 'success_8', src: success_8},

    {id: 'fail_1', src: fail_1},
    {id: 'fail_2', src: fail_2},
    {id: 'fail_3', src: fail_3},
    {id: 'fail_4', src: fail_4},
    {id: 'fail_5', src: fail_5},
    {id: 'fail_6', src: fail_6},
];

export function playSound(sound_type, robot_index, soundjs_options={}) {
    return createjs.Sound.play(idForSound(sound_type, robot_index), soundjs_options);
}

export const play = createjs.Sound.play.bind(createjs.Sound);



// WEBPACK FOOTER //
// ./src/SoundManager.js